<template>
    <div id="messages">
        <p :class="type">{{ text }}</p>
    </div>
</template>

<script>
    export default {
        name: "TheMessage",
        props: {
            text: String,
            type: String
        }
    }
</script>

<style scoped>
    #messages p {
        position: fixed;
        padding: 15px;
        border-radius: 3px;
        right: 15px;
        top: 15px;
        color: #fff;
        z-index: 99999;
    }
    #messages p.error {
        background: #e03d3d;
    }
    #messages p.success {
        background: #4bb349;
    }
    @media screen and (max-width: 480px) {
        #messages p {
            top: 0;
            right: 0;
            margin: 15px;
        }
    }
</style>